import { useCallback, useMemo } from 'react';
import { helpResources } from './HelpResources';
import { HelpContent } from './InfoIcon.types';
import { Marked } from 'marked';
import DOMPurify from 'dompurify';

interface UseHelpContentResult {
  getHelpContent: (resourceId: string) => HelpContent | null;
  parseContent: (content: string) => string;
}

const marked = new Marked();

export function useHelpContent(): UseHelpContentResult {
  const getHelpContent = useCallback((resourceId: string): HelpContent | null => {
    return helpResources[resourceId] || null;
  }, []);

  const parseContent = useCallback((content: string): string => {
    // Convert markdown to HTML and sanitize
    const htmlContent = marked.parse(content) as string;
    return DOMPurify.sanitize(htmlContent);
  }, []);

  return useMemo(() => ({
    getHelpContent,
    parseContent,
  }), [getHelpContent, parseContent]);
} 